import { useEffect, useState } from 'react'
import { listOpenCaptures } from './api'
import type { VoiceCapture } from './types'

/** The user's own concepts and unconfirmed processings; a failure is an empty list. */
export function useOpenCaptures(enabled: boolean): { captures: VoiceCapture[]; loading: boolean } {
  const [state, setState] = useState<{ captures: VoiceCapture[]; loading: boolean }>({
    captures: [],
    loading: enabled,
  })
  useEffect(() => {
    if (!enabled) return
    let alive = true
    listOpenCaptures()
      .then((captures) => alive && setState({ captures, loading: false }))
      .catch(() => alive && setState({ captures: [], loading: false }))
    return () => {
      alive = false
    }
  }, [enabled])
  return enabled ? state : { captures: [], loading: false }
}

/** The first words of a memo, for lists. */
export function previewOf(capture: VoiceCapture, max = 60): string {
  const text = (capture.transcript ?? '').replace(/\s+/g, ' ').trim()
  return text.length > max ? `${text.slice(0, max).trimEnd()}…` : text
}
